import React, { useState, useEffect, useRef } from "react";

const Modal = ({ isOpen, onClose, onSubmit, title, placeholder }) => {
  const [inputValue, setInputValue] = useState("");
  const inputRef = useRef(null);

  // Focus the input field when the modal opens
  useEffect(() => {
    if (isOpen) {
      setInputValue(""); // Clear the input value when the modal opens
      inputRef.current?.focus();
    }
  }, [isOpen]);

  const handleSubmit = () => {
    const name = inputValue.trim() || new Date().toLocaleString(); // Use date and time if no name is provided
    onSubmit(name);
    setInputValue(""); // Clear input after submission
    onClose(); // Close the modal
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSubmit(); // Submit the form when "Enter" is pressed
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-lg p-6 w-96">
        <h2 className="text-lg font-bold mb-4">{title}</h2>
        <input
          type="text"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyDown={handleKeyDown} // Handle "Enter" key
          placeholder={placeholder}
          ref={inputRef} // Attach the ref to the input field
          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
        <div className="mt-4 flex justify-end gap-2">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-200 hover:bg-gray-300 text-gray-800 rounded-lg"
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default Modal;
